/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {service as SpeciesRequestStatusService} from "../../../../../Services/SpeciesRequestStatusService";
import {usePrimeCache} from "../../../../../Hooks/ServiceHooks";
import {SpeciesModal} from "./SpeciesModal";
import {SpeciesRequestSummary} from "../../../../Common/ModelRenderers/SpeciesRequestSummary";

export const ReviewSpeciesModal = (props) => {
	
	usePrimeCache([SpeciesRequestStatusService]);
	
	const saveSpeciesRequest = async (species, statusCode = 'approved') => {
		const response = await (SpeciesRequestStatusService.FindByCode(statusCode))
		const speciesRequestStatusId = response?.result?.speciesRequestStatusId;

		return {
			...species,
			SpeciesRequest: {
				...species?.SpeciesRequest,
				speciesRequestStatusId
			}
		};
	}

	const reviewerNotesAreValid = (species) => {
		return (species?.SpeciesRequest?.reviewerNotes ?? '')?.trim() !== '';
	}

	const speciesTypeIdIsValid = (species) => {
		return Number(species?.speciesTypeId) !== 5;
	};
	
	return <SpeciesModal
		{...props}
		title="Review Species Request"
		summaryComponent={SpeciesRequestSummary}
		confirmationButtonMessage="Approve"
		onBeforeConfirm={(species) => saveSpeciesRequest(species, 'approved')}
		onBeforeDelete={(species) => saveSpeciesRequest(species, 'denied')}
		deleteButtonMessage="Deny"
		hiddenFields={[
			'fulcrumId',
			'SpeciesRequest_requested',
			'SpeciesRequest_requestedByUserId',
			'SpeciesRequest_speciesRequestSourceId',
			'SpeciesRequest_observedProjectContextNodeId',
			'SpeciesRequest_observedDate',
			'SpeciesRequest_requesterNotes',
			'SpeciesRequest_reviewed',
			'SpeciesRequest_reviewedByUserId',
			'SpeciesRequest__speciesListIds',
		]}
		disableConfirmationButton={species => !speciesTypeIdIsValid(species) ? 'Growth Form cannot be "Other"' : null}
		disableDeleteButton={species => !reviewerNotesAreValid(species) ? 'Reviewer Notes are required.' : null}
	/>;
}